import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SG_GET_EMAIL_LOGS } from 'constants/actions';
import { Link } from 'react-router-dom';
import PageIntro from '../components/PageIntro';

export default function EmailList() {
  const dispatch = useDispatch();
  const emails = useSelector((s) => s.action_email?.emails || {});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    // Initial load (no query)
    dispatch({ type: SG_GET_EMAIL_LOGS });
  }, [dispatch]);

  useEffect(() => {
    setLoading(false);
  }, [emails]);

  const list = Array.isArray(emails?.results)
    ? emails.results
    : (Array.isArray(emails) ? emails : []);

  const count = typeof emails?.count === 'number' ? emails.count : list.length;
  const fmt = (d) => (d ? new Date(d).toLocaleString() : '-');

  const toQueryPayload = (urlOrQuery) => {
    if (!urlOrQuery) return undefined;
    try {
      const u = new URL(urlOrQuery, window.location.origin);
      return u.search.startsWith('?') ? u.search.slice(1) : u.search;
    } catch {
      return urlOrQuery.startsWith('?') ? urlOrQuery.slice(1) : urlOrQuery;
    }
  };

  const prev = () => {
    if (!emails?.previous || loading) return;
    setLoading(true);
    dispatch({ type: SG_GET_EMAIL_LOGS, payload: toQueryPayload(emails.previous) });
  };

  const next = () => {
    if (!emails?.next || loading) return;
    setLoading(true);
    dispatch({ type: SG_GET_EMAIL_LOGS, payload: toQueryPayload(emails.next) });
  };

  return (
    <div>
      <PageIntro
        title="Email logs"
        description="Track emails sent as part of action planning (report delivery, invites, reminders). Use this view to check delivery status and troubleshoot send issues."
        bullets={[
          'Where data comes from: Postmark and send tasks that log delivery responses.',
          'What to expect: status, timestamps, and related campaign/event IDs where available.',
          'Next steps: inspect failures, resend as needed, or update templates.'
        ]}
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
        <div>Showing {list.length} of {count} emails</div>
        <div>
          <button onClick={prev} disabled={loading || !emails?.previous} style={{ marginRight: 8 }}>Prev</button>
          <button onClick={next} disabled={loading || !emails?.next}>Next</button>
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 8 }}>
        <thead>
          <tr>
            <th style={{ borderBottom: '1px solid #ddd', padding: 8 }}>To</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: 8 }}>Subject</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: 8 }}>Type</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: 8 }}>Status</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: 8 }}>Sent</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: 8 }}>Delivered</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: 8 }}>View</th>
          </tr>
        </thead>
        <tbody>
          {list.length ? (
            list.map((m) => (
              <tr key={m.id}>
                <td style={{ padding: 8 }}>
                  {m.to || m.recipient?.email || (typeof m.recipient === 'string' ? m.recipient : '-') }
                </td>
                <td style={{ padding: 8 }}>{m.subject || '-'}</td>
                <td style={{ padding: 8 }}>{m.email_type || '-'}</td>
                <td style={{ padding: 8 }}>{m.status || '-'}</td>
                <td style={{ padding: 8 }}>{fmt(m.sent_at)}</td>
                <td style={{ padding: 8 }}>{fmt(m.delivered_at)}</td>
                <td style={{ padding: 8 }}>
                  {m.id && m.id !== 'undefined' ? (
                    <Link to={`${m.id}`}>View</Link>
                  ) : (
                    <span style={{ color: '#9ca3af' }}>No id</span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan={7}>{loading ? 'Loading...' : 'No emails'}</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}